import { Back, Power1, TweenMax } from 'gsap';
import { getGameSize, IGameSizeInfo } from '../../Config/Levels';
// import { HudActions, HudEmitter } from '../../Managers/HudEmitter';
import { ITweenable } from './ITweenable';
import { Popup } from '../../Managers/Popups';
import { IRewardItem } from '../../State/reducers/score';
import { RewardBox } from './Win/RewardBox';

export class BotRewardPopup extends PIXI.Container implements ITweenable {
    private box: RewardBox;

    constructor(
        popupType: Popup,
        rewards: Array<IRewardItem>,
        collectionInProgress: string,
        collectionProgress: number
    ) {
        super();
        const gameSize: IGameSizeInfo = getGameSize();

        this.box = new RewardBox(
            rewards,
            'standard',
            collectionInProgress,
            collectionProgress,
            true
        );

        this.box.scale.set(1.4);
        this.box.x = gameSize.gameWidth * 0.5;
        this.box.y = gameSize.gameHeight * 1.5;
        this.addChild(this.box);

        const ready = this.tweenIn();
        ready.catch(() => {});
    }

    public async tweenIn() {
        TweenMax.to(this.box, 1.2, {
            y: getGameSize().gameHeight * 0.3,
            ease: Back.easeOut,
            onComplete: () => {
                this.box.initBox();
            },
        });
    }

    public async tweenOut() {
        TweenMax.to(this, 0.6, {
            alpha: 0,
            delay: 0.3,
            ease: Power1.easeIn,
            onComplete: () => {
                this.destroy();
            },
        });

        return;
    }
}
